module.exports = {
    "All": "Tous",
    "Any": "Tous"
}


// WEBPACK FOOTER //
// ./src/l10n-messages/fr/location_select.js